<script lang="ts" setup>
	useBodyLock();
</script>

<template>
	<slot />
</template>

<style scoped lang="scss"></style>
